import { z } from 'zod';

import { ModelIdSchema } from './model-tiers';

// Exported as a tuple so the co-located Drizzle column can reuse it as its enum.
// Order is not significant.
export const FEEDBACK_CATEGORIES = [
  'praise',
  'complaint',
  'correction', // a factual fix to something the agent said
  'bug_report',
  'other',
] as const;
export const FeedbackCategorySchema = z.enum(FEEDBACK_CATEGORIES);
export type FeedbackCategory = z.infer<typeof FeedbackCategorySchema>;

// The light classifier's enforced structured output. `category` is only meaningful
// when isFeedback is true; it is ignored otherwise.
export const FeedbackClassificationSchema = z.object({
  isFeedback: z.boolean(),
  category: FeedbackCategorySchema,
});
export type FeedbackClassification = z.infer<typeof FeedbackClassificationSchema>;

// A persisted feedback record. seq fields reference agent_messages.seq within the
// same session; targetMessageSeq is the agent reply the feedback concerns.
export const FeedbackSchema = z.object({
  id: z.uuid(),
  sessionId: z.uuid(),
  userMessageSeq: z.number().int(),
  targetMessageSeq: z.number().int().nullable(),
  category: FeedbackCategorySchema,
  classifierModel: ModelIdSchema,
  createdAt: z.string(),
});
export type Feedback = z.infer<typeof FeedbackSchema>;

// The admin triage read: recent persisted feedback, newest-first.
export const FeedbackListSchema = z.array(FeedbackSchema);
export type FeedbackList = z.infer<typeof FeedbackListSchema>;
